<template>
  <div class="device-db-static-view">
    <management-table
      title="计量报表"
      eyebrow="Metering Report"
      :data="safeTableData"
      :loading="tableLoading"
      :current-page="query.pageNum"
      :page-size="query.pageSize"
      :total="totalV1"
      empty-text="暂无数据"
      @current-change="onPageChange">
      <template slot="filters">
        <div class="search-item">
          <div class="search-label">DTU编号：</div>
          <el-input v-model="query.serNo" class="search-input" clearable placeholder="请输入DTU编号" @clear="handleClear" />
        </div>

        <div class="search-item">
          <div class="search-label">电表选择：</div>
          <el-select
            v-model="query.deviceName"
            class="search-select"
            popper-class="device-static-popper"
            clearable
            filterable
            :filter-method="deviceFilterMethod"
            placeholder="请选择电表"
            @focus="handleDeviceFocus"
            @clear="handleClear">
            <el-option
              v-for="item in filteredDeviceList"
              :key="item.imei"
              :label="item.stationName"
              :value="item.imei" />
          </el-select>
        </div>

        <div class="search-item date-item">
          <div class="search-label">查询区间：</div>
          <el-date-picker
            v-model="value1"
            class="search-date"
            popper-class="device-static-popper"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="wsss" />
        </div>

        <div class="search-item">
          <div class="search-label">导出类型：</div>
          <el-select
            v-model="query.exportType"
            class="search-select"
            popper-class="device-static-popper"
            placeholder="选择模式">
            <el-option label="按月" value="1" />
            <el-option label="按年" value="2" />
            <el-option label="累计" value="4" />
          </el-select>
        </div>

        <div v-if="query.exportType == 1" class="search-item compact-item">
          <el-date-picker
            v-model="value2"
            class="search-date"
            popper-class="device-static-popper"
            type="month"
            value-format="yyyy-MM"
            format="yyyy-MM"
            placeholder="选择月" />
        </div>

        <div v-if="query.exportType == 2" class="search-item compact-item">
          <el-date-picker
            v-model="value3"
            class="search-date"
            popper-class="device-static-popper"
            type="year"
            value-format="yyyy"
            format="yyyy"
            placeholder="选择年" />
        </div>
      </template>

      <template slot="actions">
        <el-button
          type="primary"
          icon="el-icon-download"
          class="add-btn export-btn"
          :disabled="!query.exportType"
          @click="exportData">
          导出
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-search"
          class="search-btn"
          :loading="tableLoading"
          @click="serch">
          搜索
        </el-button>
      </template>

      <template slot="columns">
        <el-table-column prop="stationName" label="电站名称" min-width="150" show-overflow-tooltip align="center" />
        <el-table-column prop="imei" label="DTU编号" min-width="140" show-overflow-tooltip align="center" />
        <el-table-column prop="deviceName" label="设备名称" min-width="150" show-overflow-tooltip align="center" />
        <el-table-column prop="deviceType" label="设备类型" min-width="110" show-overflow-tooltip align="center" />
        <el-table-column prop="kpiDay" label="日期" min-width="120" show-overflow-tooltip align="center" />
        <el-table-column label="日发电量" min-width="120" show-overflow-tooltip align="center">
          <template slot-scope="scope">{{ scope.row.todayFaDianLiang }}kwh</template>
        </el-table-column>
        <el-table-column prop="currentValue" label="当前值" min-width="110" show-overflow-tooltip align="center" />
        <el-table-column prop="kpiMonth" label="日期" min-width="120" show-overflow-tooltip align="center" />
        <el-table-column label="月发电量" min-width="120" show-overflow-tooltip align="center">
          <template slot-scope="scope">{{ scope.row.monthFaDianLiang }}kwh</template>
        </el-table-column>
        <el-table-column label="总发电量" min-width="120" show-overflow-tooltip align="center">
          <template slot-scope="scope">{{ scope.row.totalFaDianLiang }}kwh</template>
        </el-table-column>
      </template>
    </management-table>
  </div>
</template>

<script>
import ManagementTable from '../../components/ManagementTable.vue';

export default {
  name: 'DeviceDbStatic',
  components: {
    ManagementTable
  },
  data() {
    return {
      value1: [],
      deviceList: [],
      filteredDeviceList: [],
      value3: '',
      value2: '',
      tableDataV1: [],
      tableLoading: false,
      totalV1: 0,
      hasSearched: false,
      query: {
        stationName: '',
        deviceName: '',
        exportType: '',
        pageNum: 1,
        pageSize: 10,
        serNo: ''
      }
    };
  },
  computed: {
    safeTableData() {
      return Array.isArray(this.tableDataV1) ? this.tableDataV1 : [];
    }
  },
  created() {
    this.loadPage();
    this.loadAllList();
  },
  methods: {
    wsss(value) {
      this.value1 = value;
      this.loadPage();
    },
    loadAllList() {
      const queryForm = { pageNum: 1, pageSize: 10000, deviceType: 1 };
      this.$request.post('/api/device/page', queryForm).then(response => {
        const resData = response && response.data ? response.data : {};
        if (resData.result) {
          const data = resData.data || {};
          this.deviceList = Array.isArray(data.list) ? data.list : [];
          this.filteredDeviceList = this.deviceList;
        } else {
          this.deviceList = [];
          this.filteredDeviceList = [];
          this.$Message.error('获取电表列表失败,请联系管理员!');
        }
      }).catch(() => {
        this.deviceList = [];
        this.filteredDeviceList = [];
        this.$Message.error('网络异常，获取电表列表失败！');
      });
    },
    deviceFilterMethod(value) {
      if (!value) {
        this.filteredDeviceList = this.deviceList;
        return;
      }
      const keyword = value.toLowerCase();
      this.filteredDeviceList = this.deviceList.filter(item =>
        item.stationName && item.stationName.toLowerCase().startsWith(keyword)
      );
    },
    handleDeviceFocus() {
      this.filteredDeviceList = this.deviceList;
    },
    exportData() {
      if ((this.query.exportType == 1 && this.value2 === '') ||
        (this.query.exportType == 2 && this.value3 === '')) {
        this.$Message.warning('请选择导出的年月！');
        return;
      }
      if (this.query.exportType == 1) this.query.kpiTime = this.value2;
      if (this.query.exportType == 2) this.query.kpiTime = this.value3;
      if (this.query.exportType == 4) this.query.kpiTime = '';
      this.applyDateRange();

      this.$request({
        timeout: 300000,
        url: '/api/device/export/db/fadian',
        method: 'POST',
        responseType: 'blob',
        data: this.query
      }).then(res => {
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.query.kpiTime + '计量报表数据导出.xlsx';
        link.click();
        window.URL.revokeObjectURL(url);
        this.$Message.success('计量报表导出成功！');
      }).catch(() => {
        this.$Message.error('导出失败，请联系管理员！');
      });
    },
    applyDateRange() {
      if (Array.isArray(this.value1) && this.value1.length > 0) {
        this.query.startTime = this.value1[0];
        this.query.endTime = this.value1[1];
      }
    },
    loadPage() {
      this.applyDateRange();
      this.tableLoading = true;
      this.$request.post('/api/device/static/db/page', this.query).then(response => {
        const resData = response && response.data ? response.data : {};
        if (resData.result) {
          const data = resData.data || {};
          this.tableDataV1 = Array.isArray(data.list) ? data.list : [];
          this.totalV1 = Number(data.totalCount) || 0;
        } else {
          this.tableDataV1 = [];
          this.totalV1 = 0;
          this.$Message.error('获取数据失败,请联系管理员!');
        }
      }).catch(() => {
        this.tableDataV1 = [];
        this.totalV1 = 0;
        this.$Message.error('网络异常，获取数据失败！');
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    onPageChange(page) {
      this.query.pageNum = page;
      this.loadPage();
    },
    serch() {
      this.hasSearched = true;
      this.query.pageNum = 1;
      this.loadPage();
    },
    handleClear() {
      if (this.hasSearched) {
        this.serch();
      }
    }
  }
};
</script>

<style>
.device-static-popper {
  border: 1px solid #0099ff !important;
  background-color: #002b4d !important;
  color: #87cefa !important;
}

.device-static-popper .el-select-dropdown__item {
  color: #87cefa !important;
}

.device-static-popper .el-select-dropdown__item.hover,
.device-static-popper .el-select-dropdown__item:hover {
  background-color: #003c66 !important;
  color: #00ccff !important;
}

.device-static-popper .el-picker-panel__body,
.device-static-popper .el-picker-panel__sidebar {
  background-color: #002b4d !important;
  color: #87cefa !important;
}

.device-static-popper .el-date-table th,
.device-static-popper .el-picker-panel__icon-btn,
.device-static-popper .el-date-range-picker__header,
.device-static-popper .el-month-table td .cell,
.device-static-popper .el-year-table td .cell {
  color: #b0e2ff !important;
}

.device-static-popper .el-date-table td.available:hover,
.device-static-popper .el-month-table td .cell:hover,
.device-static-popper .el-year-table td .cell:hover {
  color: #00ccff !important;
}

@media (max-width: 760px) {
  .device-static-popper.el-date-range-picker {
    box-sizing: border-box;
    width: calc(100vw - 16px) !important;
    max-width: calc(100vw - 16px) !important;
    max-height: calc(100vh - 16px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  .device-static-popper.el-date-range-picker .el-picker-panel__body {
    min-width: 0 !important;
  }

  .device-static-popper.el-date-range-picker .el-date-range-picker__content {
    box-sizing: border-box;
    float: none;
    width: 100% !important;
    padding: 10px 12px;
  }

  .device-static-popper.el-date-range-picker .el-date-range-picker__content.is-left {
    border-right: 0 !important;
  }

  .device-static-popper.el-date-range-picker .el-date-range-picker__content.is-right {
    border-top: 1px solid #003567;
  }

  .device-static-popper.el-date-range-picker .el-date-table td {
    padding: 2px 0;
  }
}
</style>

<style scoped>
.device-db-static-view {
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.device-db-static-view .date-item {
  flex-basis: 360px;
  min-width: 340px;
}

.device-db-static-view .compact-item {
  flex-basis: 150px;
  min-width: 150px;
}

.search-date {
  width: 100% !important;
}

.device-db-static-view /deep/ .search-date.el-date-editor,
.device-db-static-view /deep/ .search-date.el-date-editor--daterange {
  height: 36px !important;
  border: 1px solid rgba(63, 184, 255, 0.58) !important;
  border-radius: 4px;
  background: rgba(0, 18, 36, 0.72) !important;
  color: #dff8ff !important;
  box-shadow: none !important;
  box-sizing: border-box;
}

.device-db-static-view /deep/ .search-date.el-date-editor .el-input__inner {
  height: 34px !important;
  line-height: 34px !important;
  border: 0 !important;
  background: transparent !important;
  color: #dff8ff !important;
}

.device-db-static-view /deep/ .search-date.el-date-editor--daterange {
  display: inline-flex;
  align-items: center;
  padding: 0 10px;
}

.device-db-static-view /deep/ .search-date .el-range-input {
  min-width: 0;
  background: transparent !important;
  color: #dff8ff !important;
}

.device-db-static-view /deep/ .search-date .el-range__icon,
.device-db-static-view /deep/ .search-date .el-range-separator,
.device-db-static-view /deep/ .search-date .el-range__close-icon {
  color: #87cefa !important;
}

.device-db-static-view /deep/ .search-date.el-date-editor:hover,
.device-db-static-view /deep/ .search-date.el-date-editor.is-active {
  border-color: rgba(0, 204, 255, 0.85) !important;
}

.device-db-static-view /deep/ .search-date input::placeholder {
  color: rgba(135, 206, 250, 0.62) !important;
}

.device-db-static-view /deep/ .export-btn.is-disabled,
.device-db-static-view /deep/ .export-btn.is-disabled:hover,
.device-db-static-view /deep/ .export-btn.is-disabled:focus {
  border-color: #00ccff !important;
  background: #00ccff !important;
  opacity: 0.55;
}

@media (max-width: 1200px) {
  .device-db-static-view /deep/ .management-table-search-actions {
    flex: 1 0 100%;
    justify-content: flex-start;
    margin-left: 0;
  }
}

@media (max-width: 760px) {
  .device-db-static-view .search-item,
  .device-db-static-view .date-item,
  .device-db-static-view .compact-item {
    flex: 0 0 auto;
    width: 100%;
    min-width: 0;
  }

  .device-db-static-view /deep/ .management-table-search-actions {
    flex: none;
  }

  .device-db-static-view /deep/ .export-btn.el-button,
  .device-db-static-view /deep/ .search-btn.el-button {
    width: 100%;
    min-width: 0;
  }
}
</style>
